import { PETS_APIS } from "@/api_framework/api_config";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setBreedSpecific } from "@/app_redux/reducers/slices/auth/inventory_slice";
import axios from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import { useConfiguration } from "@app/hooks/useConfiguration";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";

AxiosCurlirize(axios, () => {});

export const useBreedListAPI = () => {
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();

  const execute = useCallback(
    async (pet_species_type_id: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const res = await axios.get(`${PETS_APIS?.BREED_LIST?.baseURL}?pet_species_type_id=${pet_species_type_id}`, {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        });
        if (res.data.status === true) {
          dispatch(setBreedSpecific(res.data.data));
        } else {
          dispatch(setBreedSpecific(null));
        }
        return res.data;
      } catch (e: any) {
        captureError(e);
        sendCurl(e.config["curlCommand"]);
        dispatch(setBreedSpecific(null));
      }
    },
    [dispatch],
  );

  return { execute };
};
